import React, { createContext, useState, useContext, ReactNode, Dispatch, SetStateAction } from 'react';

interface LayoutContextProps {
  isFooterVisible: boolean;
  setFooterVisible: Dispatch<SetStateAction<boolean>>;
}

const LayoutContext = createContext<LayoutContextProps | undefined>(undefined);

export const LayoutProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isFooterVisible, setFooterVisible] = useState(true);

  return <LayoutContext.Provider value={{ isFooterVisible, setFooterVisible }}>{children}</LayoutContext.Provider>;
};

export const useLayoutContext = () => {
  const context = useContext(LayoutContext);
  if (context === undefined) {
    throw new Error('useLayoutContext must be used within a LayoutProvider');
  }
  return context;
};
